module.exports = __webpack_public_path__ + "static/media/POPINA_MENU-normal.df76c485.png";